import React from 'react';
import { Link } from 'react-router-dom';
import { useStore } from '../../context/StoreContext';
import { staticurl } from '../../common/constants';

const BrandList = ({ filterType = 'all' }) => {
  const { brands } = useStore();
  if (!brands) return null;

  const filteredBrands = brands.filter((brand) => {
    if (filterType === 'onlyOwn') return brand.ownBrand === true;
    if (filterType === 'other') return brand.ownBrand === false;
    return true;
  });

  return (
    <>
        {filteredBrands.map((brand) => (
            <Link to={`/brands/${brand.brandName}`} key={brand._id}>
            <img
                loading="lazy"
                src={`${staticurl}${brand.brandLogo.replace("/brandlogos/", "/thumbnails/")}`}
                height="120px"
                className="mx-2 c1 radius50"
                alt={brand.brandName}
            />
            </Link>
        ))}
    </>
  );
};

export default BrandList;